<template>
  <div id="app" class="is-flex is-flex-direction-column">
    <div id="head" class="is-flex is-flex-direction-row is-align-items-center">
      <b-dropdown append-to-body aria-role="list" trap-focus>

        <template #trigger>
            <b-button title="Settings" icon-right="sliders-h"></b-button>
        </template>
        <b-dropdown-item aria-role="listitem" :focusable="false" custom>

          <div class="is-flex is-flex-direction-row is-align-items-center">
            <div class="setting-label has-text-weight-bold">Layout</div>
            <div class="setting-control field has-addons">
              <p class="control is-flex-grow-1"><b-button title="" size="is-small" :type="layout === 'full' ? 'is-primary' : ''" @click="layout = 'full'" expanded>Full</b-button></p>
              <p class="control is-flex-grow-1"><b-button title="" size="is-small" :type="layout === 'square' ? 'is-primary' : ''" @click="layout = 'square'" expanded>Square</b-button></p>
              <p class="control is-flex-grow-1"><b-button title="" size="is-small" :type="layout === 'circle' ? 'is-primary' : ''" @click="layout = 'circle'" expanded>Circle</b-button></p>
            </div>
          </div>

          <div class="mt-3 is-flex is-flex-direction-row is-align-items-center">
            <div class="setting-label has-text-weight-bold">Type</div>
            <div class="setting-control field has-addons">
              <p class="control is-flex-grow-1"><b-button title="" size="is-small" :type="modus === 'rings' ? 'is-primary' : ''" @click="modus = 'rings'" expanded>Rings</b-button></p>
              <p class="control is-flex-grow-1"><b-button title="" size="is-small" :type="modus === 'spiral' ? 'is-primary' : ''" @click="modus = 'spiral'" expanded>Spiral</b-button></p>
            </div>
          </div>

          <div class="is-seperator mt-3 mb-3"></div>

          <rings-settings v-if="modus === 'rings'" v-bind:settings="settings.rings"></rings-settings>

          <spiral-settings v-if="modus === 'spiral'" v-bind:settings="settings.spiral"></spiral-settings>

          <div class="mt-3">
            <b-button size="is-small" title="Save" class="mr-3" type="is-primary" icon-left="save" @click="save"></b-button>
            <b-button size="is-small" title="Load" class="mr-3" type="is-primary" icon-left="upload" @click="load"></b-button>
            <b-button size="is-small" title="Reset" type="is-primary" icon-left="redo-alt" @click="reset"></b-button>
          </div>
        </b-dropdown-item>
      </b-dropdown>

      <div class="ml-5 mr-3 mb-0 field has-addons">
        <p class="control"><b-button title="Play" icon-left="play" :disabled="running === 'r'" @click="onPlay" /></p>
        <p class="control"><b-button title="Pause" icon-left="pause" :disabled="running === 'p' || running === 's'" @click="onPause" /></p>
        <p class="control"><b-button title="Stop" icon-left="stop"  @click="onStop" /></p>
      </div>

      <b-dropdown append-to-body aria-role="list" trap-focus>
        <template #trigger>
            <b-button title="Audio" :icon-right="volumeIcon" />
        </template>
        <b-dropdown-item aria-role="listitem" :focusable="false" custom>
          <div class="ml-2 mr-2">
            <b-slider type="is-dark" v-model="volume" :min="0" :max="1" :step="0.05" :indicator="false" :tooltip="false"></b-slider>
          </div>
          <div>
            <b-select size="is-small" icon="file-audio" v-model="audio.selected" expanded @input="onAudioChange">
                <option value="asmr">Kaa ASMR</option>
                <option value="timi">Trust In Me (Instrumental)</option>
            </b-select>
          </div>
        </b-dropdown-item>
      </b-dropdown>

      <div class="is-flex-grow-1"></div>

      <div class="ml-5 is-hidden-mobile">
        <b-button title="Copy Link" icon-right="link" :type="copied ? 'is-success' : ''"  @click="onCopyToClipboard" />
      </div>

      <div class="ml-3 is-hidden-mobile">
        <b-button title="Info" icon-right="info" @click="showInfo = !showInfo" />
      </div>

      <b-dropdown class="is-hidden-tablet" append-to-body aria-role="list" trap-focus position="is-bottom-left">
        <template #trigger>
            <b-button title="More" icon-left="ellipsis-v" :type="copied ? 'is-success' : ''"></b-button>
        </template>
        <b-dropdown-item aria-role="listitem" @click="onCopyToClipboard">
          <div class="is-flex is-flex-direction-row is-align-items-center">
            <b-button class="mr-3" size="is-small" type="is-primary" icon-right="link"/>
            <div>Copy Link</div>
          </div>
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" @click="showInfo = !showInfo">
          <div class="is-flex is-flex-direction-row is-align-items-center">
            <b-button class="mr-3" size="is-small" type="is-primary" icon-right="info"/>
            <div>Info</div>
          </div>
        </b-dropdown-item>
      </b-dropdown>

    </div>
    <div id="content" class="is-flex-grow-1">
      <native-canvas v-bind:layout="layout" v-bind:modus="modus" v-bind:settings="settings[modus]" :running="running"></native-canvas>
    </div>

    <info-modal v-bind:showInfo.sync="showInfo"></info-modal>
  </div>
</template>

<script>
import RingsSettings from './components/RingsSettings.vue'
import SpiralSettings from './components/SpiralSettings.vue'
import NativeCanvas from './components/NativeCanvas.vue'
import InfoModal from './components/InfoModal.vue'

const defaulSettings = {
  rings: () => {
    return {
      c1: '#7e99f9',
      c2: '#5fbaba',
      c3: '#d3bf2c',
      number: 3,
      stroke: 15,
      speed: 15
    }
  },
  spiral: () => {
    return {
      c1: '#6fccfb',
      c2: '#4219d7',
      radius: 10,
      stroke: 30,
      speed: 10
    }
  }
}

export default {
  name: 'App',
  components: {
    RingsSettings,
    SpiralSettings,
    NativeCanvas,
    InfoModal
  },
  data: function () {
    return {
      layout: localStorage.layout ? localStorage.layout : 'full',
      modus: localStorage.modus ? localStorage.modus : 'rings',
      settings: {
        rings: localStorage.settingsrings ? JSON.parse(localStorage.settingsrings) : defaulSettings.rings(),
        spiral: localStorage.settingsspiral ? JSON.parse(localStorage.settingsspiral) : defaulSettings.spiral()
      },
      running: 's',
      audio: {
        selected: 'asmr',
        element: null
      },
      volume: 0,
      showInfo: false,
      copied: null
    }
  },
  methods: {
    onPlay: function () {
      this.running = 'r'
      if (this.audio.element) this.audio.element.play()
    },
    onPause: function () {
      this.running = 'p'
      if (this.audio.element) {
        this.audio.element.pause()
      }
    },
    onStop: function () {
      this.running = 's'
      if (this.audio.element) {
        this.audio.element.pause()
        this.audio.element.currentTime = 0
      }
    },
    onAudioChange: function () {
      if (this.audio.element) {
        this.audio.element.pause()
        this.audio.element.currentTime = 0
        this.audio.element.src = require(`../src/assets/${this.audio.selected}.mp3`)
        if (this.running === 'r') this.audio.element.play()
      }
    },
    onCopyToClipboard: async function () {
      try {
        let params = `?l=${this.layout}&m=${this.modus}`
        if (this.modus === 'rings') {
          const c1 = this.settings.rings.c1.slice(1)
          const c2 = this.settings.rings.c2.slice(1)
          const c3 = this.settings.rings.c3.slice(1)
          params = params + `&c1=${c1}&c2=${c2}&c3=${c3}&n=${this.settings.rings.number}&st=${this.settings.rings.stroke}&sp=${this.settings.rings.speed}`
        } else if (this.modus === 'spiral') {
          const c1 = this.settings.spiral.c1.slice(1)
          const c2 = this.settings.spiral.c2.slice(1)
          params = params + `&c1=${c1}&c2=${c2}&r=${this.settings.spiral.radius}&st=${this.settings.spiral.stroke}&sp=${this.settings.spiral.speed}`
        }
        const url = window.location.href.split('?')[0] + params
        await navigator.clipboard.writeText(url)
        clearTimeout(this.copied)
        this.copied = setTimeout(() => {
          this.copied = null
        }, 300)
      } catch (error) {
        console.error(error)
      }
    },
    save: function () {
      localStorage[`settings${this.modus}`] = JSON.stringify(this.settings[this.modus])
    },
    load: function () {
      if (localStorage[`settings${this.modus}`]) this.settings[this.modus] = JSON.parse(localStorage[`settings${this.modus}`])
    },
    reset: function () {
      this.settings[this.modus] = defaulSettings[this.modus]()
    }
  },
  watch: {
    layout: function () {
      localStorage.layout = this.layout
    },
    modus: function () {
      localStorage.modus = this.modus
    },
    volume: function (newVolume) {
      this.audio.element.volume = newVolume * 0.4
    }
  },
  computed: {
    volumeIcon: function () {
      if (this.volume === 0) {
        return 'volume-mute'
      } else if (this.volume < 0.6) {
        return 'volume-down'
      } else {
        return 'volume-up'
      }
    }
  },
  created: function () {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('l') === 'full' || urlParams.get('l') === 'square' || urlParams.get('l') === 'circle') this.layout = urlParams.get('l')
    if (urlParams.get('m') === 'rings') {
      this.modus = 'rings'
      if (urlParams.get('c1')) this.settings.rings.c1 = '#' + urlParams.get('c1')
      if (urlParams.get('c2')) this.settings.rings.c2 = '#' + urlParams.get('c2')
      if (urlParams.get('c3')) this.settings.rings.c3 = '#' + urlParams.get('c3')
      if (urlParams.get('n')) this.settings.rings.number = Math.min(10, Math.max(1, parseInt(urlParams.get('n'))))
      if (urlParams.get('st')) this.settings.rings.stroke = Math.min(50, Math.max(5, parseInt(urlParams.get('st'))))
      if (urlParams.get('sp')) this.settings.rings.speed = Math.min(30, Math.max(10, parseInt(urlParams.get('sp'))))
    } else if (urlParams.get('m') === 'spiral') {
      this.modus = 'spiral'
      if (urlParams.get('c1')) this.settings.spiral.c1 = '#' + urlParams.get('c1')
      if (urlParams.get('c2')) this.settings.spiral.c2 = '#' + urlParams.get('c2')
      if (urlParams.get('r')) this.settings.spiral.radius = Math.min(20, Math.max(1, parseInt(urlParams.get('r'))))
      if (urlParams.get('st')) this.settings.spiral.stroke = Math.min(50, Math.max(1, parseInt(urlParams.get('st'))))
      if (urlParams.get('sp')) this.settings.spiral.speed = Math.min(30, Math.max(1, parseInt(urlParams.get('sp'))))
    }
  },
  mounted: function () {
    this.audio.element = new Audio()
    this.audio.element.preload = 'auto'
    this.audio.element.volume = this.volume
    this.audio.element.loop = true
    this.audio.element.src = require(`../src/assets/${this.audio.selected}.mp3`)
  }
}
</script>

<style lang="scss">
/*
.button:active, .button.is-active, button:focus, .button.is-focused {
  border-color: #dbdbdb !important;
}

.button:focus:not(:active), .button.is-focused:not(:active) {
 box-shadow: none !important;
}
*/

#app {
  height: 100%;
  background-color: #484848;
}
#head {
  height: 60px;
  min-height: 60px;
  background-color: #363636;
  padding: 0 15px;
}

.b-tabs {
  margin-bottom: 0 !important;
}
.setting-label {
  width: 65px;
  min-width: 65px;
}
.setting-control {
  min-width: 200px;
  flex-grow: 1;
}
.is-seperator {
  height: 1px;
  background-color: #363636;
}

#content {
  overflow: hidden;
  text-align: center;
}
</style>
